// extracted by mini-css-extract-plugin
export default {"container":"style__container--jyVK6"};